import React, {Component} from 'react';
import Resize from 'react-resize-detector';
import PropTypes from 'prop-types';

import * as d3 from 'd3';
import _ from 'lodash';

import HoverOver from '../HoverOver';

import StateOutline from "../Map/StateOutline";
import StateCountyHovers from "../Map/StateCountyHovers";
import StateCountyBorders from "../Map/StateCountyBorders";
import StateMapShapes from "./StateMapShapes";

import '../Map/Map.css';
import './StateMap.css';
import StateCityLabels from "../Map/StateCityLabels";

class StateMap extends Component {

  constructor(props) {
    super(props);

    this.state = {
      width: 500,
      height: 500
    };
  }

  componentDidMount() {
    this.handelResize(this.refs.wrapper.offsetWidth)
  }

  handelResize(width = 500) {
    const heightDivisor = window.innerWidth > 960 ? .65 : .9;
    const maxHeight = this.props.maxHeight || width;
    this.setState({width: width, height: Math.min(maxHeight, width * heightDivisor)});
  }

  render() {
    const self = this;

    return (
      <div ref="wrapper" className="StateMap" height={this.state.height}>
        <Resize handleWidth onResize={this.handelResize.bind(this)}/>
        <svg width={this.state.width} height={this.state.height}>
          <StateOutline stateFips={this.props.stateFips} width={this.state.width} height={this.state.height}/>
          <StateMapShapes
            stateFips={this.props.stateFips}
            data={this.props.data}
            dict={this.props.dict}
            width={this.state.width}
            height={this.state.height}
            dimX={this.props.dimX}
            dimY={this.props.dimY}
            year={this.props.year}
            type={this.props.type}
          />
          <StateCountyBorders stateFips={this.props.stateFips} width={this.state.width} height={this.state.height}/>
          <StateCountyHovers
            width={this.state.width}
            height={this.state.height}
            stateFips={this.props.stateFips}
            onHoverOver={(countyFips, coords) => {
              const hover = {
                data: _.get(self, ['props', 'dict', countyFips], null),
                props:self.props,
                coords,
              };
              self.setState({hover});
              d3.selectAll("#FIPS_" + countyFips).attr("class", "hover_over");
            }}
            onHoverOut={countyFips => {
              d3.selectAll("#FIPS_" + countyFips).attr("class", "hover_out");
              self.setState({hover: null})
            }}
            onClick={(stateFips, countyFips) => {
              if (this.props.onClick) {
                this.props.onClick(stateFips, countyFips)
              }
            }}/>
          {this.props.showCities && (
            <StateCityLabels stateFips={this.props.stateFips} width={this.state.width} height={this.state.height}/>
          )}
        </svg>
        <HoverOver data={this.state.hover}/>
      </div>
    );
  }
}

StateMap.propTypes = {
  maxHeight: PropTypes.number,
  stateFips: PropTypes.number,
  onClick: PropTypes.func,
  titleX: PropTypes.string,
  titleY: PropTypes.string,
  dimX: PropTypes.string,
  dimY: PropTypes.string,
  year: PropTypes.number,
  type: PropTypes.string,
  data: PropTypes.array,
  dict: PropTypes.object,
  showCities: PropTypes.bool,
  useHeatScale: PropTypes.bool
};

export default StateMap;


// WEBPACK FOOTER //
// ./src/charts/StateMap/index.js